import logger from "@cayo/shared/libs/logger";
import { urlUtils } from "@cayo/shared/utils/url";

const redirectParameterName = "redirectUrl";

const log = logger.getLogger("redirect-utils");

const getLoginUrl = () => {
  return `/login?${redirectParameterName}=` + urlUtils.trim(window.location.hash);
};

const getRelativeRedirectUrl = () => {
  const redirectUrl = getRedirectUrl();
  if (redirectUrl?.startsWith("http://") || redirectUrl?.startsWith("https://")) {
    return new URL(redirectUrl).hash;
  }

  if (redirectUrl && !redirectUrl.startsWith("/") && !redirectUrl.startsWith("#")) {
    return "#/" + redirectUrl;
  }

  return redirectUrl;
};

const getRedirectUrl = () => {
  const pos = window.location.hash.indexOf("?");
  const queryParams = new URLSearchParams(window.location.hash.substring(pos));
  const redirectUrl = queryParams.get(redirectParameterName);
  log.log("redirectUrl: " + redirectUrl);

  return queryParams.get(redirectParameterName) || "/";
};

const redirectUtils = {
  getLoginUrl,
  redirectParameterName,
  getRelativeRedirectUrl,
  getRedirectUrl,
};

export default redirectUtils;
